import React, { useContext, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Trans } from '@lingui/react';
import { TransButtonDefault, TransButtonDefaultWithIcon, TransButtonPrimary } from '../../../Atoms/Buttons';
import { ConfirmDialog, ModalDialog, useModalState } from '../../../Molecules/Dialogs';
import { deleteMessageTemplate, patchEmailTemplate } from '../../../Service/restapi/messageService';
import GenericTemplateName from '../../../Molecules/Settings/GenericTemplateName';

export default function ({ messageType, templateName }) {
  const [modalDelete, setModalDelete] = useState(false);
  const { show, toggle } = useModalState(false);
  const [newName, setNewName] = useState(templateName);
  const [disableSave, setDisableSave] = useState(false);
  const navigate = useNavigate();

  if (messageType.toUpperCase() !== 'CUSTOM') {
    return null;
  }

  function deleteHandler() {
    deleteMessageTemplate(messageType, templateName)
      .then((resp) => {
        if (resp.ok) {
          navigate('/settings/messages');
        } else {
          console.error(`could not delete messageTemplate ${messageType} ${templateName}`);
        }
      })
      .catch((error) => {
        console.error({ error });
        console.error(`could not delete messageTemplate ${messageType} ${templateName}`);
      });
  }

  function changeName() {
    const template = newName.trim();
    patchEmailTemplate(messageType, templateName, { name: template })
      .then((resp) => {
        if (resp.ok) {
          navigate(`/settings/template/message/custom/${template}`);
        } else {
          console.error(`could not save message template ${templateName} under new name ${template}`);
        }
      })
      .catch(() => {
        console.error(`could not save message template ${templateName} under new name ${template}`);
      });
  }

  const styles = {
    actionContainer: {
      display: 'flex',
      alignSelf: 'center',
    },
    button: {
      marginLeft: 5,
    },
  };

  return (
    <div style={styles.actionContainer}>
      <div style={styles.child}>
        <TransButtonDefault onClickHandler={toggle} text="Namen der Vorlage ändern" />
      </div>

      <ModalDialog
        header={<Trans id="Name der Vorlage ändern" />}
        body={
          <div>
            <div>Wähle einen Namen für diese Vorlage:</div>
            <GenericTemplateName
              disableSave={setDisableSave}
              documentType="CUSTOM"
              name={document.name}
              newName={newName}
              setNewName={setNewName}
            />
          </div>
        }
        footer={
          <div>
            <TransButtonPrimary
              disabled={disableSave}
              onClickHandler={() => {
                changeName();
                toggle();
              }}
              text="actions.save"
            />{' '}
            <TransButtonDefault onClickHandler={toggle} text="actions.cancel" />
          </div>
        }
        show={show}
        toggle={toggle}
      />

      <TransButtonDefaultWithIcon
        style={styles.button}
        onClickHandler={() => setModalDelete(!modalDelete)}
        icon="TRASH"
      />

      <ConfirmDialog
        text="common.delete.messageTemplate.confirm"
        subject="common.delete.messageTemplate.confirm.head"
        open={modalDelete}
        toggle={() => setModalDelete(!modalDelete)}
        handler={deleteHandler}
      />
    </div>
  );
}
